import {FAN_RADIAN, LIGHT_R, R} from "./dimension";

export const drawFan = (ctx, color, imgData, cx, cy, i) => {
    ctx.beginPath();
    ctx.moveTo(cx, cy);

    ctx.arc(
        cx,
        cy,
        R - LIGHT_R - 3,
        1.5 * Math.PI + i * FAN_RADIAN,
        1.5 * Math.PI + (i + 1) * FAN_RADIAN
    );
    ctx.lineTo(cx, cy);
    ctx.fillStyle = color;
    ctx.fill(); // or context.fill()


    ctx.drawImage(
        imgData[0],
        imgData[1][0],
        imgData[1][1],
        imgData[2][0],
        imgData[2][1]
    );
};

export const drawFans = (ctx, colors, v, cx, cy) => {
    v.forEach((imgData, i) => {
        drawFan(ctx, colors[i], imgData, cx, cy, i);
    });
};
